module.exports = __webpack_public_path__ + "img/NP6.10cc587c.jpeg";